<template>
  <footer>
    <div
      class="footer-container"
      :style="{
        '--footer-bgColor': this.$store.state.template.header.bgColorFooter,
        '--footer-textColor': this.$store.state.template.header.textColorFooter ?? this.$store.state.template.header.menuColor,
      }">
      <div class="permanent-footer">
        <a class="footer-item" href="https://www.blitzar.com.br/" target="_blank" v-if="!hideBlitzar">
          <!-- <img class="blitzar-b" src="@/assets/logo_minimal_negativo.png" alt=""> -->
          <svg
            class="blitzar-b"
            :fill="this.$store.state.template.header.menuColor"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 482 469"
            style="enable-background: new 0 0 482 469"
            xml:space="preserve">
            <g transform="translate(0.000000,469.000000) scale(0.100000,-0.100000)">
              <path
                d="M799,3006.5c5.8-1753,1.4-1652.4,83.4-1909.8c92-283.3,325-598.2,543.6-736.3l44.6-28.8v2144.2V4620h-338H793.2L799,3006.5
		z" />
              <path
                d="M2244.3,3412c-174-21.6-478.9-105-519.2-142.4c-5.8-5.8-8.6-184.1-7.2-395.5l4.3-385.4l57.5,47.5
		c204.2,163.9,611.2,230.1,920.4,149.6c313.5-80.5,523.5-304.9,586.7-625.6c33.1-163.9,41.7-323.6,25.9-474.6
		c-30.2-274.7-99.2-442.9-240.2-583.9c-123.7-123.7-244.5-179.8-504.8-230.1l-33.1-5.8V428c0-312.1,1.4-338,25.9-338
		c56.1,1.4,233,31.6,339.4,59c257.4,66.2,471.7,187,655.8,372.5c299.1,297.7,445.8,706.1,445.8,1229.6
		c-1.4,769.4-327.9,1305.8-947.7,1553.1C2818.1,3397.6,2484.4,3442.2,2244.3,3412z" />
              <path
                d="M1926.4,832.1c-185.5-69-289.1-268.9-235.8-455.9C1774,92.9,2137.8,9.5,2336.3,230.9c53.2,59,97.8,172.6,97.8,247.4
		c0,122.2-82,258.9-195.6,325C2159.4,850.8,2011.3,863.7,1926.4,832.1z" />
            </g>
          </svg>
        </a>
        <a class="footer-item" :class="{ 'disable-on-mobile-if-disclaimer': eventDisclaimer }" v-if="!hideBlitzar" href="https://www.blitzar.com.br/" target="_blank">Todos os direitos reservados - Blitzar © {{ yearOfEvent }}</a>
        <span class="footer-item-disclaimer" v-html="eventDisclaimer" v-if="eventDisclaimer"></span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      eventDisclaimer: '',
      hideBlitzar: true,
      accessConfig: {
        footerImages: [],
      },
    };
  },
  computed: {
    yearOfEvent() {
      const eventCreationDate = new Date();
      return eventCreationDate.getFullYear();
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.eventDisclaimer = this.$store.state.template.eventDisclaimer ? this.$store.state.template.eventDisclaimer : '';
    this.hideBlitzar = this.$store.state.template.hideBlitzar ? this.$store.state.template.hideBlitzar : false;
  },
};
</script>

<style lang="scss">
footer {
  position: fixed;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  bottom: 0;
  width: 100vw;
  z-index: 100;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
}
.footer-container {
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.permanent-footer {
  position: relative;
  background: var(--footer-bgColor);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100vw;
  height: 32px;
  padding: 0 10px;
  @include media('<=phone') {
    padding: 0 6px;
  }
}
.blitzar-b {
  height: 20px;
  width: 20px;
  @include media('<=phone') {
  }
}
.footer-item {
  font-size: 12px;
  margin-right: 10px;
  color: var(--footer-textColor) !important;
  text-decoration: none;
  font-size: 12px;
  @include media('<=phone') {
    margin-right: 4px;
  }
}
.footer-item-disclaimer {
  font-size: 12px;
  margin: 0 10px 0 auto;
  color: var(--footer-textColor) !important;
  @include media('<=phone') {
    font-size: 2.5vw;
    margin: 0 auto;
  }
}
.disable-on-mobile-if-disclaimer {
  @include media('<=phone-plus') {
    display: none !important;
  }
}
.footer-wrapper {
  position: fixed;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
